function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/classNames';
/**
 * The UiLayerItem component handles rendering of a specific layer item to a specific layer as
 * defined in `@sie/web-common-layers`. The functionality of ths component is driven by
 * the `@sie/web-common-layers` package and although can be used alone the
 * `UiLayers` component should be preferred as it provides a more complete integration
 * with that package.
 *
 * - [Web Common Layers Docs](https://github.sie.sony.com/pages/SIE/web-common-toolkit/core/layers/)
 *
 * ## Related Components
 * - [UiLayers](../../UiLayers/README.md)
 *
 * ## Props
 */

var UiLayerItem = /*#__PURE__*/function (_PureComponent) {
  _inherits(UiLayerItem, _PureComponent);

  var _super = _createSuper(UiLayerItem);

  function UiLayerItem() {
    var _this;

    _classCallCheck(this, UiLayerItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(UiLayerItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var item = this.props.item;
      this.off = item.on('update', function (update) {
        return _this2.setState(function (prev) {
          return _objectSpread(_objectSpread({}, prev), update);
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.off === 'function') {
        this.off();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          children = _this$props.children,
          elevation = _this$props.elevation,
          item = _this$props.item;
      var isHidden = this.state.isHidden;
      return /*#__PURE__*/React.createElement("div", {
        "data-layer-item-id": item.id,
        "data-qa": qa,
        className: classNames(className, isHidden && 'psw-hidden'),
        style: {
          zIndex: elevation,
          pointerEvents: 'none'
        }
      }, children(this.state));
    }
  }]);

  return UiLayerItem;
}(PureComponent);

UiLayerItem.defaultProps = {
  qa: '',
  className: ''
};
UiLayerItem.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The elevation (z-index) of the layer item
   */
  elevation: PropTypes.number.isRequired,

  /**
   * Render prop for rendering the associated layer item component
   */
  children: PropTypes.func.isRequired,

  /**
   * The layer item instance from `@sie/web-common-layers`
   */
  item: PropTypes.shape({
    /**
     * Adds an event callback to be called when events occur on the layer item
     */
    on: PropTypes.func,

    /**
     * removes all event callbacks on the layer item
     */
    off: PropTypes.func
  }).isRequired
};
export default UiLayerItem;